const YEAR_IN_SECONDS = 31536000;
const MONTH_IN_SECONDS = 2592000;
const DAY_IN_SECONDS = 86400;
const HOUR_IN_SECONDS = 3600;
const MINUTE_IN_SECONDS = 60;

export const getLastOnlineLabel = (lastTimestamp) => {
  if (!lastTimestamp) {
    return '';
  }

  const seconds = Math.floor((Date.now() - lastTimestamp) / 1000);

  let interval = seconds / YEAR_IN_SECONDS;

  if (interval >= 1) {
    interval = Math.floor(interval);
    return `${interval} year${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  interval = seconds / MONTH_IN_SECONDS;

  if (interval >= 1) {
    interval = Math.floor(interval);
    return `${interval} month${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  interval = seconds / DAY_IN_SECONDS;

  if (interval >= 1) {
    interval = Math.floor(interval);
    return `${interval} day${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  interval = seconds / HOUR_IN_SECONDS;

  if (interval >= 1) {
    interval = Math.floor(interval);
    return `${interval} hour${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  interval = seconds / MINUTE_IN_SECONDS;

  if (interval >= 1) {
    interval = Math.floor(interval);
    return `${interval} minute${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  return `${Math.floor(seconds)} second${seconds !== 1 ? 's' : ''} ago`;
};

export const getPublishedDateLabel = (timeInMillis) => {
  const seconds = Math.floor((Date.now() - timeInMillis) / 1000);

  let interval = seconds / DAY_IN_SECONDS;

  if (interval > 2) {
    return new Intl.DateTimeFormat('en-US', {dateStyle: 'medium'}).format(timeInMillis);
  }

  if (interval > 1) {
    return 'Yesterday';
  }

  interval = seconds / HOUR_IN_SECONDS;

  if (interval > 1) {
    interval = Math.floor(interval);
    return `${interval} hour${interval % 10 !== 1 ? 's' : ''} ago`;
  }

  interval = seconds / MINUTE_IN_SECONDS;

  if (interval > 1) {
    interval = Math.floor(interval);
    return `${interval} minute${interval % 10 !== 1 ? 's' : ''} ago`;
  }
  return '1 minute ago';
};

export const getFormattedDate = (date, timeZone) => {
  const dateOptions = timeZone ? {timeZone} : {};
  return date
    ? new Intl.DateTimeFormat(window.navigator.language, dateOptions).format(new Date(date))
    : '';
};

export const ONE_DAY = 1000 * 60 * 60 * 24;
